import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { AppEntities } from "../config/entities";

export const saveObjectToExcel = (object: any, documentInfo: any) => {
  if (!object) {
    console.error("Object is undefined or null");
    return;
  }

  const headerMarkers = {
    start: "StartHeader",
    end: "EndHeader",
  };

  const tableMarkers = {
    start: "StartTablePart",
    end: "EndTablePart",
  };

  const worksheetData = [];

  let isHeaderSection = true;

  Object.entries(object).forEach(([key, value]) => {
    if (Array.isArray(value) && value.length > 0) {
      if (!isHeaderSection) {
        worksheetData.push([headerMarkers.end]);
      }

      worksheetData.push([`${tableMarkers.start} ${key}`]);
      worksheetData.push(Object.keys(value[0]));

      value.forEach((item) => {
        const itemValues = Object.values(item);
        worksheetData.push(itemValues);
      });

      worksheetData.push([`${tableMarkers.end}`]);

      isHeaderSection = false;
    } else {
      if (isHeaderSection) {
        worksheetData.push([headerMarkers.start]);
        isHeaderSection = false;
      }
      worksheetData.push([key, value]);
    }
  });

  if (!isHeaderSection) {
    worksheetData.push([]);
  }

  const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
  const excelBuffer = XLSX.write(workbook, {
    bookType: "xlsx",
    type: "array",
  });

  const excelData = new Blob([excelBuffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
  });

  const fileName: any = generateFileName(documentInfo);
  saveAs(excelData, fileName);
};

const generateFileName = (documentInfo: any) => {
  const { title, number, date } = documentInfo;
  const formattedDate = date
    ? new Date(date).toLocaleDateString("en-US")
    : "UnknownDate";
  return `${title}, ${number} from ${formattedDate}.xlsx`;
};

export const importFromExcel = (file: File, callback: (data: any) => void) => {
  const reader = new FileReader();
  reader.onload = (event) => {
    const binaryString = event.target?.result;
    const workbook = XLSX.read(binaryString, { type: "binary" });
    const sheetName = workbook.SheetNames[0];
    const worksheet = workbook.Sheets[sheetName];
    const worksheetData: any = XLSX.utils.sheet_to_json(worksheet, {
      header: 1,
    });

    const data: any = {};

    let currentSection = null;

    for (let i = 0; i < worksheetData.length; i++) {
      const row = worksheetData[i];

      if (row.length >= 1) {
        const firstCell = String(row[0]);

        if (firstCell.startsWith("StartTablePart")) {
          const tableName = firstCell.split(" ")[1];
          currentSection = tableName;
          data[currentSection] = [];
        } else if (firstCell === "EndTablePart") {
          currentSection = null;
        } else if (currentSection) {
          data[currentSection].push(row);
        } else if (row.length >= 2) {
          const key = row[0];
          const value = row[1];
          data[key] = value;
        }
      }
    }

    const formattedData: any = {};

    for (const section in data) {
      if (Array.isArray(data[section])) {
        const sectionData: any[] = data[section].slice(1).map((row: any[]) => {
          const obj: any = {};
          row.forEach((value, index) => {
            const header = data[section][0][index];
            obj[header] = value;
          });
          return obj;
        });
        formattedData[section] = sectionData;
      } else {
        formattedData[section] = data[section];
      }
    }

    callback(formattedData);
  };
  reader.readAsBinaryString(file);
};
